"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buryingPointRouteGuard;
var _BuryingPoint = _interopRequireWildcard(require("@ys/crm-common/dist/utils/BuryingPoint"));
var _store = _interopRequireDefault(require("@/store"));
function buryingPointRouteGuard(router) {
  let loginBuryingPoint;
  router.beforeEach(async (_to, _from, next) => {
    if (!_store.default.getters.accessToken) {
      if (loginBuryingPoint) {
        loginBuryingPoint.stop();
      }
      next();
      return;
    }
    if (!loginBuryingPoint) {
      loginBuryingPoint = new _BuryingPoint.default({
        type: _BuryingPoint.BuryingPointType.Login,
        source: _BuryingPoint.BuryingPointSource.Pc
      });
    }
    next();
  });
}